import { useField } from 'formik';

import { SupplierCompanySelect, type SupplierCompanySelectProps } from '../CompanySelect/SupplierCompanySelect';

interface FormikSupplierCompanySelectProps extends Omit<SupplierCompanySelectProps, 'onChange' | 'value'> {
    name: string;
}

export function FormikSupplierCompanySelect(props: FormikSupplierCompanySelectProps) {
    const [field, meta, helpers] = useField<string>(props.name);

    const onChange = (supplierId: string) => {
        helpers.setValue(supplierId);
    };

    return (
        <SupplierCompanySelect
            {...props}
            onChange={onChange}
            value={field.value}
            negative={meta.touched && !!meta.error}
            caption={meta.touched && meta.error ? meta.error : props.caption}
            onBlur={() => {
                helpers.setTouched(true);
            }}
        />
    );
}
